import { Box, Button, Menu, MenuItem } from "@mui/material";
import { useState } from "react";
import { outlinedProps, shadowProps } from "./constant";
import { MenuType, Props } from "./models";

export default function MenuSelector<T = any>({
  onClick,
  selectedValue,
  menuItems,
  menuType = MenuType.outlined,
  sx,
  labelText,
  actionIcon
 }: Props<T>) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const selectedItem = menuItems.find(x => x.value === selectedValue);

  const handleMenuOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleSelection = (result: T) => {
    setAnchorEl(null);
    onClick(result as T);
  };

  const buttonSettings: any = menuType === MenuType.outlined ? outlinedProps : shadowProps;

  return (
    <>
      <Button onClick={handleMenuOpen}
        color={buttonSettings.color}
        variant={buttonSettings.variant}
        sx={{...buttonSettings.sx, ...sx}}
      >
        <Box sx={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "flex",
          alignItems: "center",
          gap: "4px"
        }}>
          { actionIcon }
          {labelText ?? selectedItem?.label}
      </Box>
        {buttonSettings.downArrowIcon}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: "left" }}
        slotProps={{ paper: anchorEl ? { style: { minWidth: `${anchorEl.offsetWidth}px` } } : undefined }}
      >
        {menuItems.map((item, i) =>
          <MenuItem
            onClick={() => handleSelection(item.value)}
            disabled={item.disabled}
            key={i}
          >{item.label}</MenuItem>)
        }
      </Menu>
    </>
  )
}
